import { Box, Flex } from "rebass";
import hideIcon from "../../static/images/icon-accordion-close-transparent.png";
import showIcon from "../../static/images/icon-accordion-open-transparent.png";
import { getLocalizedString } from "../../utils";
import { getLocalizedText } from "../../utils/getLocalizedText";
import Tooltip from "../common/Tooltip";

const FilterItem = ({
  name,
  label,
  options,
  values,
  open,
  onSelect,
  onToggleOpen,
  sx,
  ...props
}) => {
  return options?.length > 1 ? (
    <Box sx={{ marginBottom: "10px", ...sx }} {...props}>
      <Flex
        alignItems={"center"}
        pl={3}
        style={{
          fontSize: "0.8em",
          position: "relative",
          backgroundColor: "#EEE",
          height: "50px",
          borderBottom: "1px dotted #888",
        }}
        onClick={() => onToggleOpen(name)}
      >
        {label}
        <Tooltip content={getLocalizedString("ACCORDION_HIDE")}>
          <img
            alt=""
            className={"absolute " + (!open?.includes(name) ? "hidden" : "")}
            style={{ right: "15px" }}
            src={hideIcon}
            width={20}
            height={22}
          />
        </Tooltip>
        <Tooltip content={getLocalizedString("ACCORDION_SHOW")}>
          <img
            alt=""
            className={"absolute " + (open?.includes(name) ? "hidden" : "")}
            // onClick={onToggleOpen}
            style={{ right: "15px" }}
            src={showIcon}
            width={20}
            height={22}
          />
        </Tooltip>
      </Flex>
      <Flex
        flexDirection={"column"}
        w={1}
        p={3}
        style={{
          backgroundColor: "#EEE",
          visibility: !open?.includes(name) ? "hidden" : "",
          display: !open?.includes(name) ? "none" : "",
        }}
      >
        {options.map((item, index) => (
          <Flex className="w-full flex" fontSize="0.8em" mb={1} key={index}>
            <input
              className="hernoCheckbox p-2"
              onChange={onSelect}
              type="checkbox"
              data-value={item.id}
              id={"collection_" + item.id}
              style={{ width: "20px" }}
              checked={values?.includes(item.id)}
            />{" "}
            <span
              style={{
                marginLeft: "10px",
                color: item.disabled ? "#888888" : "black",
              }}
            >
              {getLocalizedText(item?.description)}
            </span>
          </Flex>
        ))}
      </Flex>
    </Box>
  ) : null;
};

export default FilterItem;
